import { Input } from "@legal-500/legal500-design-system";
import { useForm } from "react-hook-form";
import { withoutEmpty } from "./blockContent";
import { BackgroundField, RichTextField, useSyncBlockContent } from "./blockEditorParts";
import type { BlockContentErrors, TextContent } from "./types";
import styles from "../CMS.module.css";

type TextBlockEditorProps = {
  value: TextContent;
  onChange: (value: TextContent) => void;
  errors?: BlockContentErrors;
};

export function TextBlockEditor({ value, onChange, errors = {} }: TextBlockEditorProps) {
  const { control, register, watch } = useForm<TextContent>({ defaultValues: value });
  useSyncBlockContent(watch, value, content => onChange(withoutEmpty(content, ["anchorId"])));

  return (
    <div className={styles.cardEditorFields}>
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="text-heading">
          Heading
        </label>
        <Input id="text-heading" {...register("heading")} />
      </div>
      <RichTextField control={control} name="body" id="text-body" label="Body" minHeight={240} />
      <BackgroundField register={register} name="background" stored={value.background} />
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="text-anchor-id">
          Anchor id (optional)
        </label>
        <Input
          id="text-anchor-id"
          helperText="Lowercase letters, numbers and hyphens. Link to it with #anchor-id."
          error={errors.anchorId}
          {...register("anchorId")}
        />
      </div>
    </div>
  );
}
